import moment from "moment";
import {
  DesignFamily,
  DesignProduct,
  DesignFromDB,
  ShippingTier,
  ComboItems,
  ItemPricing,
} from "../types";
import { ProductFamilyList, ProductList } from "../constant/common.constant";

export const sortByUpdatedDate = (a: any, b: any) => {
  if (moment(a.updatedAt).isAfter(moment(b.updatedAt))) {
    return -1;
  } else {
    return 1;
  }
};

type ValueWithShippingTier = {
  tier: ShippingTier;
} & any;
export const sortByShippingOption = (
  a: ValueWithShippingTier,
  b: ValueWithShippingTier
) => {
  if (a.tier === "standard") return -1;
  if (b.tier === "standard") return 1;
  return 0;
};

export const sortDesigns = (
  a: DesignFromDB & {
    isFavorite?: boolean;
    createdAt: Date;
    updatedAt: Date;
    family?: DesignFamily;
    product?: DesignProduct;
  },
  b: DesignFromDB & {
    isFavorite?: boolean;
    createdAt: Date;
    updatedAt: Date;
    family?: DesignFamily;
    product?: DesignProduct;
  }
) => {
  // 1. Favorited
  if (a.isFavorite && !b.isFavorite) return -1;
  if (!a.isFavorite && b.isFavorite) return 1;

  // 2. Product family
  const aFamilyIndex = ProductFamilyList.findIndex(
    (pf) => pf.id === a.family?.name
  );
  const bFamilyIndex = ProductFamilyList.findIndex(
    (pf) => pf.id === b.family?.name
  );

  if (
    aFamilyIndex !== -1 &&
    bFamilyIndex !== -1 &&
    aFamilyIndex !== bFamilyIndex
  ) {
    return aFamilyIndex - bFamilyIndex;
  }

  // 3. Product
  const aProductIndex = ProductList.findIndex(
    (p) =>
      p.family.name === a.family?.name && p.product.name === a.product?.name
  );
  const bProductIndex = ProductList.findIndex(
    (p) =>
      p.family.name === b.family?.name && p.product.name === b.product?.name
  );

  if (
    aProductIndex !== -1 &&
    bProductIndex !== -1 &&
    aProductIndex !== bProductIndex
  ) {
    return aProductIndex - bProductIndex;
  }

  // 4. Last modified
  if (moment(a.updatedAt).isAfter(moment(b.updatedAt))) {
    return -1;
  }
  if (moment(b.updatedAt).isAfter(moment(a.updatedAt))) {
    return 1;
  }

  return 0;
};

export const sortPreorderItems = (
  a: ItemPricing & {
    comboItem: ComboItems;
  },
  b: ItemPricing & {
    comboItem: ComboItems;
  }
) => {
  // 2. Product family
  const aFamilyIndex = ProductFamilyList.findIndex(
    (pf) => pf.id === a.comboItem.familyName
  );
  const bFamilyIndex = ProductFamilyList.findIndex(
    (pf) => pf.id === b.comboItem.familyName
  );

  if (
    aFamilyIndex !== -1 &&
    bFamilyIndex !== -1 &&
    aFamilyIndex !== bFamilyIndex
  ) {
    return aFamilyIndex - bFamilyIndex;
  }

  // 3. Product
  const aProductIndex = ProductList.findIndex(
    (p) =>
      p.family.name === a.comboItem.familyName &&
      p.product.name === a.productName
  );
  const bProductIndex = ProductList.findIndex(
    (p) =>
      p.family.name === b.comboItem.familyName &&
      p.product.name === b.productName
  );

  if (
    aProductIndex !== -1 &&
    bProductIndex !== -1 &&
    aProductIndex !== bProductIndex
  ) {
    return aProductIndex - bProductIndex;
  }

  return 0;
};
